<template>
  <div class="l-content">
    <section class="l-section parallax banner banner-desktop"></section>
    <section class="l-section banner-mobile">
      <img class="banner-static" :src=mImage />
    </section>
    <section class="l-section overlay"></section>
    <section class="l-section flex-column header mt-3">
      <img class="logo" src="../assets/bsLogoWhite.png">
      <div class="text-quote mt-2">{{mQuote}}</div>
    </section>
    <section class="l-section flex-column">
      <div class="text-title mt-5 ml-auto mr-auto">{{mTitle}}</div>
      <div class="text-subtitle ml-auto mr-auto">{{mSubtitle}}</div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'RowBannerHeader',
  data () {
    return {
      mImage: require('../assets/bkgBannerResize.jpg'),
      mQuote: 'Simply, Better IOT',
      mTitle: 'BetterSense',
      mSubtitle: 'We turn your IOT data into intelligence\n' +
        'From any sensor on any network, get your data in one place, in real time.\n' +
        'Now is good'
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .l-debug {
    border-width: 1px;
    border-color: red;
    border-style: dashed;
  }
  .l-content {
    position: relative;
    height: 100%;
  }
  .l-section {
    position: absolute;
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    color: white;
  }
  .banner-static {
    display: inline-block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .banner-desktop {
    display: block;
  }
  .banner-mobile {
    display: none;
  }
  .parallax::after {
    content: " ";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    transform: translateZ(-1px) scale(1.5);
    background-size: 100%;
    z-index: -1;
  }
  .banner::after {
    background-image: url('../assets/bkgBannerResize.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.25;
  }
  .header {
    position: absolute;
    justify-content: start;
  }
  .logo {
    width: 10rem;
    margin-left: auto;
    margin-right: auto;
  }
  .text-quote {
    color: #fcfcfc;
    font-weight: bold;
    margin-left: auto;
    margin-right: auto;
  }
  .text-title {
    color: #fcfcfc;
    font-weight: bolder;
    font-size: 5rem;
  }
  .text-subtitle {
    width: 60%;
    color: #fcfcfc;
    font-weight: normal;
    font-size: large;
  }
  @media screen and (max-width: 768px) {
    .l-content {
      height: 32rem;
    }
    .banner-desktop {
      display: none;
    }
    .banner-mobile {
      display: block;
    }
    .text-title {
      font-size: 2.8rem;
    }
    .text-subtitle {
      width: 90%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RowParallaxHeader.vue